<template>
    <vAccountComponent :postList="postList" v-if="flag"></vAccountComponent>
</template>
<script>
import vAccountComponent from '../../listComponent/basicdata/account/accountComponent.vue';
export default {
    name: 'account',
    components: {
        vAccountComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                name: true,
                social_credit_code: true,
                parent_name: true,
                huantong_code: true,
                sf_code: true,
                identity_type: true,
                province_rid: true,
                city_rid: true,
                type: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                uploadBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>